import React from 'react';
import { HashRouter, Route, Switch /*, Redirect */ } from 'react-router-dom';
import './scss/style.scss';

// Páginas
import Sobre from './views/pages/sobre';
import AtenaNovoChamado from './views/pages/atena/AtenaNovoChamado';
import AtenaTratamentoChamado from './views/pages/atena/AtenaTratamentoChamado';
import AtenaNotificacoes from './views/pages/atena/AtenaNotificacoes';   // <-- novo
import AtenaMeusChamados from './views/pages/atena/AtenaMeusChamados';   // <-- novo

const loading = (<p className="text-center">Carregando ...</p>);

// Páginas públicas (lazy)
const Login = React.lazy(() => import('./views/pages/Login'));
const ForgotPassword = React.lazy(() => import('./views/pages/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./views/pages/ResetPassword'));
const TrocarSenhaForcada = React.lazy(() => import('./views/pages/usuario/TrocarSenhaForcada'));
const TrocarSenha = React.lazy(() => import('./views/pages/usuario/TrocarSenha'));

// Layout protegido
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

export default function App() {
  return (
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          {/* ------ Rotas públicas ------ */}
          <Route exact path="/login"            name="Login Page"           render={(props) => <Login {...props} />} />
          <Route exact path="/forgot-password"  name="Esqueci minha senha"  render={(props) => <ForgotPassword {...props} />} />
          <Route exact path="/reset-password"   name="Redefinir senha"      render={(props) => <ResetPassword {...props} />} />
          <Route exact path="/trocar-senha"     name="Trocar Senha"         render={(props) => <TrocarSenhaForcada {...props} />} />
          <Route exact path="/trocarsenha"      name="TrocarSenha"          render={(props) => <TrocarSenha {...props} />} />
          <Route exact path="/sobre"            component={Sobre} />

          {/* ------ Atena ------ */}
          <Route exact path="/atena/novo"                component={AtenaNovoChamado} />
          <Route exact path="/atena/tratamento/:id"      component={AtenaTratamentoChamado} />
          <Route exact path="/atena/notificacoes"        component={AtenaNotificacoes} />  {/* novo */}
          <Route exact path="/atena/chamados"            component={AtenaMeusChamados} />  {/* novo */}

          {/* ------ Rotas protegidas (fica por último) ------ */}
          <Route path="/" name="Home" render={(props) => <TheLayout {...props} />} />

          {/* Opcional: redirecionar qualquer rota desconhecida
          <Redirect to="/login" /> */}
        </Switch>
      </React.Suspense>
    </HashRouter>
  );
}
